import 'moment/locale/de'

import { makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { inject } from 'mobx-react'
import moment from 'moment'
import { I18N, i18n, LocalisationStore } from 'utils/localisation'

const momentHash: { [dateISOString: string]: moment.Moment } = {}

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    position: 'relative',
  },
  date: {
    textAlign: 'center',
    padding: theme.spacing(3.75, 1.25),
  },
  timeline: {
    position: 'absolute',
    width: theme.spacing(1),
    top: 0,
    left: theme.spacing(2),
    height: '100%',
    background: `linear-gradient(${theme.palette.grey[200]}, ${theme.palette.grey.main}, ${theme.palette.grey[200]})`,
    borderBottomLeftRadius: '1px',
  },
}))

interface IDateSeparatorInject {
  localisationStore: LocalisationStore
}
const NotDecoratedDateSeparator = (props: {
  date: Date
  hasPrevActivity?: boolean
  localisationStore?: LocalisationStore
}) => {
  const { date, hasPrevActivity, localisationStore } = props
  const isoDate = date.toISOString()
  const hashedDate = momentHash[isoDate]
  const momentDate = hashedDate || moment(date)
  if (!hashedDate) {
    momentHash[isoDate] = momentDate
  }

  const dayDiff = momentDate.startOf('day').diff(moment(moment.now()).startOf('day'), 'days')
  let separatorMsg: string
  switch (dayDiff) {
    case 0:
      separatorMsg = 'activity-feed_date_separator_today'
      break
    case -1:
      separatorMsg = 'activity-feed_date_separator_yesterday'
      break
    default: {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      momentDate.locale(localisationStore.current)
      separatorMsg = momentDate.format('dddd[,] MMMM Do YYYY')
    }
  }
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {hasPrevActivity && <div className={classes.timeline} />}
      <div
        className={classes.date}
        style={{
          paddingTop: hasPrevActivity ? '30px' : 0,
        }}
      >
        <Typography variant="subtitle2" color="textSecondary">
          <I18N term={separatorMsg} />
        </Typography>
      </div>
    </div>
  )
}

export const DateSeparator = i18n(
  inject(
    (ctx: IDateSeparatorInject): IDateSeparatorInject => ({
      localisationStore: ctx.localisationStore,
    })
  )(NotDecoratedDateSeparator)
)
